<ng-container *ngIf="state.diffs as diffs; else noDiff">
  <div class="border-b">
    <div class="p-2 flex">
      <div class="text-gray-800">
        <div class="font-semibold">
          {{ commit.title }}
        </div>
        <div class="mt-1 flex items-center fs-07">
          <y42-user-avatar
            class="inline-block mr-1"
            [user]="state.user"
            [userIdentity]="commit.authorEmail"
            size="20"
          ></y42-user-avatar>
          <span class="mr-3">{{ commit.authorName }}</span>
          <fa-icon class="mr-1 fs-07 text-gray-700" [icon]="['fal', 'code-commit']"></fa-icon>
          <a href="" matTooltip="Checkout this commit as a new branch" (click)="tryToCheckout(commit.hash)">{{
            commit.hash
          }}</a>
          <ng-container *ngIf="!filePath">
            <fa-icon class="ml-3 mr-1 fs-07 text-gray-700" [icon]="['fal', 'pen']"></fa-icon>
            <span>{{ (diffs || []).length }} changed file{{ (diffs || []).length === 1 ? '' : 's' }}</span>
          </ng-container>
        </div>
      </div>
      <div class="ml-auto" *ngIf="canRevert">
        <button mat-raised-button (click)="revert()" class="bg-orange-700 font-medium text-white">
          <div class="ml-[-5px]">
            <fa-icon class="fs-08 text-capitalize" [icon]="['fal', 'code-commit']"></fa-icon>&nbsp;Revert
            {{ filePath ? (isDir ? 'directory' : 'file') : 'commit' }}
          </div>
        </button>
      </div>
    </div>
    <div *ngIf="commit.description" class="p-2 border-t max-h-12 fs-07 overflow-auto">
      <b>Description:</b> {{ commit.description }}
    </div>
  </div>
  <as-split [useTransition]="true" [gutterSize]="6">
    <as-split-area [size]="30" *ngIf="showDiffList" [order]="0">
      <y42-git-diff-tree
        class="block h-full border-common"
        [changes]="state.diffs"
        [allowCheckboxSelection]="false"
        [(activeItem)]="activeDiff"
      ></y42-git-diff-tree>
    </as-split-area>
    <as-split-area [size]="70" class="flex relative" [order]="1">
      <ng-container *ngIf="activeDiff">
        <div
          *ngIf="diffs.length && !state.showBlame"
          class="merge-editor h-full w-full"
          y42MonacoDiffEditor
          [fileName]="activeDiff.path"
          [original]="activeDiff.fileContents![0]"
          [modified]="activeDiff.fileContents![1]"
          (editorInitialized)="onMonacoEditorInit($event)"
        ></div>
        <ng-container *ngIf="state.showBlame">
          <y42-git-file-blame
            [path]="activeDiff.path"
            [commitSha]="commit.hash"
            class="flex flex-col h-full w-full"
          ></y42-git-file-blame>
          <button
            mat-button
            class="absolute left-0 top-0"
            matTooltip="Close Blame Preview"
            (click)="showBlame$.next(false)"
          >
            <fa-icon class="fs-09" [icon]="['fal', 'times']"></fa-icon>
          </button>
        </ng-container>
      </ng-container>
    </as-split-area>
  </as-split>
</ng-container>

<ng-template #noDiff>
  <div class="empty-table h-full" *ngIf="!getDiffLoading && !loading">
    <img height="130" src="assets/images/no-filediff.svg" />
    <div class="empty-table-header mt-2">No File Diffs Available</div>
  </div>
</ng-template>

<ng-container *ngIf="getDiffLoading || loading">
  <mat-progress-bar
    *ngIf="commit || loading || getDiffLoading; else emptyTmpl"
    class="absolute"
    mode="indeterminate"
  ></mat-progress-bar>
  <ng-template #emptyTmpl>
    <div class="center-absolute">No commit selected</div>
  </ng-template>
</ng-container>
